export default "__VITE_ASSET__CypALCis__"